// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.96-TSS-3094-mcastro-PHASE-2-ENRICHING-DOCUMENTS-COLUMN-Bulk-Download-Filters.2";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
